/**
 * API地址配置文件
 * 吴程飞
 * 2019-03-12 08:23:03
 */
const host = "http://192.168.1.200"
//中心重要服务
export const CenterImportant = host + '/center-important-business';
//中心一般服务
export const CenterGeneral = host + '/center-general-business';
//小程序服务
export const RunlegMiniApp = host + '/runleg-business';
//商家一般服务
export const MarketGeneral = host + '/marketnormalbusiness';
//商家重要服务
export const MarketImportant = host + '/marketimportantbusiness';
//用户重要服务
export const MemeberImportant = host + "/member-important";
//用户一般服务
export const MemeberGeneral = host + "/member-general";
//骑手orderhistory
export const RiderOrderhistory = host + "/orderhistorynew";
//骑手orderprocess
export const RiderOrderprocess = host + "/orderprocessnew";

export const BackMerchantManagementImportant = host + "/backstageimportant";



// WEBPACK FOOTER //
// ./src/BaseOfflineApiConfig.js